import lottie from "lottie-web-light";
import React, { useEffect, useRef } from "react";
import FAQ from "../components/FAQ";
import GetStarted from "../components/GetStarted";
import Icon from "../components/Icon";
import Image from "../components/Image";
import SEO from "../components/SEO";
import Layout from "../components/_refactored/Layout";
import { club100 } from "../constants/escrow-account";
import { faqData } from "../content/escrow-account";
import { useLottie } from "../hooks";
import EscrowManagement from "../partials/escrow-account/escrow-management";
import EscrowSolution from "../partials/escrow-account/escrow-solution";
import PlugAndPlay from "../partials/escrow-account/plug-and-play";
import TailorMade from "../partials/escrow-account/tailor-made";
import WhyChooseUs from "../partials/escrow-account/why-choose-us";
import { CASHFREE_DOC_OVER_VIEW } from "../constants/Url";

const EscrowAccountPage = (props) => {
  const escrowAni = useRef();
  const animationData = useLottie(
    "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Escrow.json",
  );
  useEffect(() => {
    if (animationData) {
      lottie.loadAnimation({
        container: escrowAni.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData,
      });
    }
  }, [animationData]);
  return (
    <Layout lightHeader {...props}>
      <SEO
        title="Escrow account for 100% secure transactions | Cashfree Payments"
        description="One Escrow by Cashfree Payments: the bridge of trust for buyers & sellers. Tailor-made for your use case. Marketplaces, D2C, co-lending,  investments etc"
        url="https://www.cashfree.com/escrow-account/"
        keywords={[
          "escrow account",
          "escrow",
          "escrow payment",
          "escrow services",
          "escrow bank account",
        ]}
      />

      {/* hero section */}
      <section className="pt-[110px] pb-[36px] md:pb-[43px] escrow-account-hero overflow-hidden relative">
        <div className="container position-relative gradient-bg">
          <div className="flex flex-wrap md:justify-between">
            <div className="relative z-[1] w-full md:w-[50%] lg:self-center text-white">
              <h2 className="text-sm font-semibold  pl-5 mb-[10px] uppercase relative before:bg-cf-green before:h-[10px] before:w-[10px] before:absolute before:top-[4px] before:left-[4px] font-body">
                ONE ESCROW
              </h2>
              <div className="mb-5 text-[27px] text-xl md:text-2xl font-semibold max-w-[565px] font-heading">
                Your Trusted Partner for All-in-One&nbsp;
                <h2 className="text-[27px] text-xl md:text-2xl font-heading inline">
                  Escrow Services
                </h2>
              </div>
              <div className="text-opacity-80 mb-8 max-w-[576px] text-[16px] leading-[24px] md:text-2.5md text-cf-cold-purple">
                Secure your transactions with &apos;One Escrow&apos;. Verify
                parties, sign custom agreements, create&nbsp;
                <h1 className="inline text-[16px] md:text-2.5md font-body font-normal">
                  escrow accounts
                </h1>{" "}
                , hold funds securely, and transact with utmost confidence.
              </div>
              <p className="font-semibold">Powered by</p>
              <ul className="p-0 mt-[24px] md:mt-[10px] mb-4 md:mb-[48px] list-none max-w-full flex flex-wrap flex-row md:items-center justify-start">
                {[
                  {
                    id: 0,
                    listItem: "Leading Scheduled Commercial Banks",
                  },
                  {
                    id: 1,
                    listItem: "SEBI-backed Trustees",
                  },
                ].map(({ id, listItem }) => (
                  <li
                    key={id}
                    className="mb-[15px] items-center md:mb-0 mr-[24px] lg:mr-4 xl:mr-[24px] last:mr-0 flex">
                    <span className="w-5 h-5 flex flex-none justify-center items-center rounded-full mr-2 bg-white  bg-opacity-25">
                      <Icon
                        name="tick"
                        width="9.21px"
                        height="6.29px"
                        fill="#fff"
                      />
                    </span>
                    <h3 className="font-body !m-0 text-2.5sm md:text-md font-normal">
                      {listItem}
                    </h3>
                  </li>
                ))}
              </ul>
              <a
                className="button button-green wide w-full md:w-auto"
                href="/contact-sales?source-action=One%20Escrow&action=Contact%20Sales&button-id=ContactSales_Hero">
                Talk to our escrow expert <span className="chevron" />
              </a>
            </div>
            <div className="relative z-[1] w-full md:w-[50%] mt-14 md:mt-0">
              <div className="mx-auto">
                <div ref={escrowAni} />
              </div>
            </div>
          </div>
        </div>
        <section className="mt-[36px] md:mt-8 logos text-white">
          <div className="container">
            <p className="text-[20px] mb-6 text-center font-semibold">
              Join the 100% Club
            </p>
            <div className="flex justify-between header-escrow-icons">
              {club100.map(({ id, img, title, description }) => (
                <div key={id} className="flex">
                  <Image
                    src={img}
                    alt={description}
                    width="60"
                    height="60"
                    className="mr-[20px]"
                  />
                  <div>
                    <p className="font-bold">{title}</p>
                    <p>{description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </section>

      {/* Achieve 3X faster go-live with Cashfree's premier modular escrow solution */}
      <EscrowSolution />

      {/* Achieve 3X faster go-live with Cashfree's premier modular escrow solution */}
      <PlugAndPlay />

      {/* Tailor-made to fit your business use cases */}
      <TailorMade />

      {/* Not just any other Escrow Management Platform section */}
      <EscrowManagement />

      {/* Why choose us? section */}
      <WhyChooseUs />

      {/* faq */}
      <div className="container general-faqs large-faqs">
        <FAQ open="0" supportLinkHref={CASHFREE_DOC_OVER_VIEW} data={faqData} />
      </div>

      {/* footer */}
      <GetStarted utmSourceAction="source-action=One%20Escrow" />
    </Layout>
  );
};

export default EscrowAccountPage;
